import { useSites } from '../../../context/SiteContext';
import { useSiteVisits } from '../../../hooks/useSiteVisits';
import { onlineCount } from '../../../lib/analytics';
import { formatDateTime } from '../../../lib/format';
import { classifySource, visitPagePath } from '../../../lib/source';
import { detectSpider, inferIsp, parseSearch } from '../../../lib/parse';
import { deviceLabel } from '../../../lib/ua';
import EmptyState from '../../../components/dashboard/EmptyState';
import StatTable from '../../../components/dashboard/StatTable';

export default function RealtimePage() {
  const { currentSite } = useSites();
  const visits = useSiteVisits(currentSite, 2000);

  if (!currentSite) {
    return <EmptyState title="先添加一个站点" desc="添加站点后可在这里查看刚刚到来的访客。" />;
  }

  return (
    <div>
      <div className="flex items-end justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground-950">实时访客</h1>
          <p className="mt-1 text-sm text-foreground-600">按访问时间倒序，自动刷新最新来访。</p>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground-700">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
          当前在线 {onlineCount(visits.filter((v) => !detectSpider(v.userAgent)))} 人
        </div>
      </div>

      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable
          columns={['时间', 'IP', '地域', '运营商', '来源 / 搜索词', '受访页', '终端', '蜘蛛']}
          rows={visits.slice(0, 80).map((v) => {
            const search = parseSearch(v.referrer, v.pageUrl);
            const spider = detectSpider(v.userAgent);
            return [
              formatDateTime(v.createdAt),
              v.ip,
              [v.province, v.city].filter(Boolean).join(' ') || v.city,
              inferIsp(v.ip, v.isp),
              search.keyword ? `${search.engine} / ${search.keyword}` : classifySource(v.referrer, v.pageUrl),
              visitPagePath(v.pageUrl),
              `${deviceLabel(v.device)} · ${v.browser}`,
              spider || '—',
            ];
          })}
          empty="还没有访问记录。把统计代码装上并打开网站后，这里会显示来访。"
        />
      </div>
    </div>
  );
}
